module.exports = __webpack_public_path__ + "img/icon-happy-staff@3x.ee36b3e8.png";